import { Typography } from '@interstate/components/Typography';
import { Button } from '@interstate/components/Button';
import { TrashIcon } from '@interstate/components/Icons';
import type { ReactNode } from 'react';
import { LayoutHeaderRow } from './housingAndEmployment.styles';

type CustomerFieldsLayoutHeaderProps = {
    children: ReactNode;
    onDelete?: () => void;
    deleteTestId?: string;
    disabled?: boolean;
};

export const CustomerFieldsLayoutHeader = ({
    children,
    onDelete,
    deleteTestId = 'delete-customer-housing-section',
    disabled
}: CustomerFieldsLayoutHeaderProps) => (
    <LayoutHeaderRow>
        <Typography variant="h6">{children}</Typography>
        {onDelete && (
            <Button
                size="sm"
                buttonStyle="secondary"
                sx={{ minWidth: '2rem' }}
                onClick={onDelete}
                disabled={disabled}
                data-testid={deleteTestId}
            >
                <TrashIcon />
            </Button>
        )}
    </LayoutHeaderRow>
);

export default CustomerFieldsLayoutHeader;
